import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import SessionService from '../../services/session.service';


const Twofaroute = ({component: Component, ...rest}) => {
    
    return (
        
        <Route {...rest} render={props => (
            SessionService.getCookie("is2faVerified")==='N'?
                <Component {...props} i18n={rest.i18n}/>
            : <Redirect to="/login"/>
        )} />
    );
};

export default Twofaroute;